export const DOT_CLASSES = {
  bigDotActive: 'dots-container__dot dots-container__dot--selected',
  bigDotInactive: 'dots-container__dot dots-container__dot--big',
  smallDot: 'dots-container__dot dots-container__dot--small',
}

export const DOT_CONTAINER_CLASSES = {
  dotsContainer: 'dots-container',
  dotsContainerCenteredContent: 'dots-container dots-container--content-centered',
}
